"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _classCallCheck = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Session = void 0;

var js_sha256_1 = require("js-sha256");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var util_1 = require("../util");

var STORAGE_KEY_SESSION_ID = "session:id";
var STORAGE_KEY_SESSION_SECRET = "session:secret";
var STORAGE_KEY_SESSION_LINKED = "session:linked";

var Session = /*#__PURE__*/function () {
  function Session(storage, id, secret, linked) {
    _classCallCheck(this, Session);

    this._storage = storage;
    this._id = id || (0, util_1.randomBytesHex)(16);
    this._secret = secret || (0, util_1.randomBytesHex)(32);
    var hash = js_sha256_1.sha256.create();
    hash.update("".concat(this._id, ", ").concat(this._secret, " WalletLink"));
    this._key = hash.hex();
    this._linked = !!linked;
  }

  _createClass(Session, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "secret",
    get: function get() {
      return this._secret;
    }
  }, {
    key: "key",
    get: function get() {
      return this._key;
    }
  }, {
    key: "linked",
    get: function get() {
      return this._linked;
    },
    set: function set(val) {
      this._linked = val;
      this.persistLinked();
    }
  }, {
    key: "save",
    value: function save() {
      this._storage.setItem(STORAGE_KEY_SESSION_ID, this._id);

      this._storage.setItem(STORAGE_KEY_SESSION_SECRET, this._secret);

      this.persistLinked();
      return this;
    }
  }, {
    key: "persistLinked",
    value: function persistLinked() {
      this._storage.setItem(STORAGE_KEY_SESSION_LINKED, this._linked ? "1" : "0");
    }
  }], [{
    key: "load",
    value: function load(storage) {
      var id = storage.getItem(STORAGE_KEY_SESSION_ID);
      var linked = storage.getItem(STORAGE_KEY_SESSION_LINKED);
      var secret = storage.getItem(STORAGE_KEY_SESSION_SECRET);

      if (id && secret) {
        return new Session(storage, id, secret, linked === "1");
      }

      return null;
    }
  }, {
    key: "persistedSessionIdChange$",
    get: function get() {
      return (0, rxjs_1.fromEvent)(window, "storage").pipe((0, operators_1.filter)(function (evt) {
        return evt.key === STORAGE_KEY_SESSION_ID;
      }), (0, operators_1.map)(function (evt) {
        return {
          oldValue: evt.oldValue || null,
          newValue: evt.newValue || null
        };
      }));
    }
    /**
     * Takes in a session ID and returns the sha256 hash of it.
     * @param sessionId session ID
     */

  }, {
    key: "hash",
    value: function hash(sessionId) {
      var hash = js_sha256_1.sha256.create();
      return hash.update(sessionId).hex();
    }
  }]);

  return Session;
}();

exports.Session = Session;